<script setup lang="ts">
	import { cn } from '@/helpers/cn'
	import { useAttrs } from 'vue'

	const attrs = useAttrs()
</script>

<template>
	<div
		:class="cn('p-5 rounded-md shadow-sm border', attrs.class as string)"
		v-bind="attrs"
	>
		<slot></slot>
	</div>
</template>
